export const CARGAR_CUENTASBANCARIAS = 'CARGAR_CUENTASBANCARIAS';
export const CARGAR_ITEMS_PLANILLA_DEPCHEQUE = 'CARGAR_ITEMS_PLANILLA_DEPCHEQUE';
export const ACTUALIZARSELECCION_CHEQUESDISTRIBUIDOS = 'ACTUALIZARSELECCION_CHEQUESDISTRIBUIDOS';
export const CARGAR_PLANILLA_DEPCHEQUE = 'CARGAR_PLANILLA_DEPCHEQUE';
export const CARGAR_PLANILLAS_DEPCHEQUE = 'CARGAR_PLANILLAS_DEPCHEQUE';